import * as React from 'react';
import { FocusScope } from '@react-aria/focus';
import { usePreventScroll } from '@react-aria/overlays';
import clsx from 'clsx';
import { useIsolate } from '../../../hooks/useIsolate';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Overlay-root_d8uUy"
};
function Overlay({
  preventBodyScroll = false,
  children,
  className
}) {
  usePreventScroll({
    isDisabled: !preventBodyScroll
  });
  const undo = useIsolate();
  React.useEffect(() => () => undo(), []);
  return /*#__PURE__*/_jsx(Base, {
    className: clsx(styles.root, className),
    children: /*#__PURE__*/_jsx(FocusScope, {
      contain: true,
      restoreFocus: true,
      autoFocus: true,
      children: children
    })
  });
}
Overlay.displayName = 'Overlay';
export { Overlay };